/**
 * Firebase bootstrap for Asgard storefront chat (loaded after Firebase compat SDKs).
 * Paired with snippets/asgard-chat.liquid — keep script order: app, auth, firestore, this file, chat-core, widget.
 */
(function() {
  try {
    if (!window.firebase) return;
    if (!firebase.apps || firebase.apps.length === 0) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCo2dTSzB7qvJ399LhiD-lGgjt4Q9lYOmA',
        authDomain: 'asgard.lokiusa.com',
        projectId: 'asgard-a7f4e',
        storageBucket: 'asgard-a7f4e.firebasestorage.app',
        messagingSenderId: '604297227446',
        appId: '1:604297227446:web:ded4b2f7940e85b3d80a17',
        measurementId: 'G-CPMWG7K20N'
      });
    }
    if (!window.db && window.firebase.firestore) window.db = window.firebase.firestore();
    if (!window.auth && window.firebase.auth) window.auth = window.firebase.auth();
    if (window.auth && typeof window.auth.signInAnonymously === 'function') {
      var auth = window.auth;
      var Persistence = window.firebase.auth.Auth && window.firebase.auth.Auth.Persistence;
      function signInAnon() {
        return auth.signInAnonymously();
      }
      if (Persistence && typeof auth.setPersistence === 'function') {
        auth.setPersistence(Persistence.SESSION).then(signInAnon).catch(signInAnon);
      } else {
        signInAnon();
      }
    }
  } catch (e) {
    if (typeof console !== 'undefined' && console.error) {
      console.error('Firebase init (Asgard chat):', e);
    }
  }
})();
